import { IconButton, Modal } from "@fluentui/react";
import { useEffect, useRef, useState } from "react";
import { IAlarm } from "../../Models/IAlarm";
import { ISentinel } from "../../Models/ISentinel";
import { useOpenAlarms } from "../../Utils/OpenAlarmsStore";
import VideoFrame from "../VideoFrame/VideoFrame";
import "./VideoDialog.scss";

// Finestra del video aperta dalle card della Home (letto e varco).

// Aperta/chiusa: si chiude da sola quando un altro video parte («close-all-video-streams») e quando
// arriva un allarme nuovo (la finestra dell'allarme deve restare in primo piano)
export const useVideoDialog = () => {
  const [open, setOpen] = useState<boolean>(false);
  const { alarms } = useOpenAlarms();
  const seen = useRef<Set<number>>(new Set(alarms.map((x: IAlarm) => x.id)));

  useEffect(() => {
    const close = () => setOpen(false);
    document.addEventListener("close-all-video-streams", close);
    return () => document.removeEventListener("close-all-video-streams", close);
  }, []);

  useEffect(() => {
    const fresh = alarms.some((x: IAlarm) => !seen.current.has(x.id));
    seen.current = new Set(alarms.map((x: IAlarm) => x.id));
    if (fresh) setOpen(false);
  }, [alarms]);

  const show = () => {
    // un solo video alla volta, come nella finestra dell'allarme
    document.dispatchEvent(new Event("close-all-video-streams"));
    setTimeout(() => setOpen(true), 100);
  };

  return { open, show, close: () => setOpen(false) };
};

export interface IVideoDialogProps {
  sentinel: ISentinel;
  // nome del dispositivo: titolo della finestra
  name: string;
  onDismiss: () => void;
}

const VideoDialog = (props: IVideoDialogProps) => {
  const titleId = "video-dialog-title-" + props.sentinel.id;
  return (
    <Modal isOpen onDismiss={props.onDismiss} titleAriaId={titleId} containerClassName="video-dialog">
      <div className="video-dialog-head">
        <div id={titleId} className="video-dialog-title">
          {props.name}
        </div>
        <IconButton
          className="video-dialog-close"
          iconProps={{ iconName: "Cancel" }}
          title="Chiudi"
          ariaLabel="Chiudi il video"
          onClick={props.onDismiss}
        />
      </div>
      <div className="video-dialog-frame">
        <VideoFrame
          sentinel={props.sentinel}
          index={0}
          width="100%"
          height="100%"
          cameraName={props.name}
          onClose={props.onDismiss}
        />
      </div>
    </Modal>
  );
};

export default VideoDialog;
